(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seduce-oil-trio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('seduce-oil-trio')) {
  customElements.define('seduce-oil-trio', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.selects = [...this.querySelectorAll('select')];
      this.button = this.querySelector('button');
      this.status = this.querySelector('.oil-trio__status');
      this.form = this.querySelector('form');
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => this.submit(event));
      this.update();
    }
    selected() { return this.selects.map(select => select.selectedOptions[0]).filter(option => option.value); }
    counts(options) { return options.reduce((counts, option) => { counts[option.value] = (counts[option.value] || 0) + 1; return counts; }, {}); }
    update() {
      const options = this.selected();
      const counts = this.counts(options);
      const valid = options.length === 3 && options.every(option => !option.dataset.unavailable && counts[option.value] <= Number(option.dataset.limit));
      this.querySelector('.oil-trio__total').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'}).format(options.reduce((sum, option) => sum + Number(option.dataset.price), 0) / 100);
      this.querySelector('.oil-trio__summary').textContent = options.map(option => option.dataset.name + ' · 50ml').join(' / ');
      this.button.disabled = !valid || this.dataset.enabled !== 'true' || this.busy;
      this.status.textContent = options.length === 3 && !valid ? this.dataset.stock : '';
      return valid;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || !this.update() || this.dataset.enabled !== 'true') return;
      this.busy = true;
      this.button.disabled = true;
      const options = this.selected();
      const counts = this.counts(options);
      const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
      try {
        const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error(this.dataset.error);
        const cart = await cartResponse.json();
        for (const option of options) {
          const existing = cart.items.filter(item => String(item.variant_id) === option.value).reduce((sum, item) => sum + item.quantity, 0);
          if (existing + counts[option.value] > Number(option.dataset.limit)) throw new Error(this.dataset.stock);
        }
        const group = crypto.randomUUID();
        const scents = options.map(option => option.dataset.name + ' (50ml)').join(' / ');
        const items = Object.entries(counts).map(([id, quantity]) => ({id:Number(id), quantity, properties:{'Collection set':'Choose three · 50ml oils', 'Selected scents':scents, '_oil_trio':group}}));
        const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.stock);
        const cartPath = root + 'cart';
          window.location.assign(root + 'discount/' + encodeURIComponent(this.dataset.discount) + '?redirect=' + encodeURIComponent(cartPath));
      } catch (error) {
        this.busy = false;
        this.update();
        this.status.textContent = error.message || this.dataset.error;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
